import { DENOMINATOR_QUERY_ALIAS } from '@modules/quantify/constants';
import {
  IntegrationType,
  MetadataDetailsViewFragment,
} from 'generated/graphql';
import { SourceNameWithNamespace } from 'v2/core/entities/fields';
import { UseExecuteEQLInput } from 'v2/core/repository/edge-server/types';
import { EQLFunctionName, ExpressionType } from 'v2/core/repository/eql/types';
import { combineWhereClauses } from 'v2/core/services/queryBuilder/combineWhereClauses';
import { OperationType } from 'v2/core/services/queryBuilder/whereClause';
import { sourceWhereClauseGenerator } from 'v2/core/services/queryBuilder/whereClauseGenerator';

export const getEqlPropsForMetadataCoverage = (
  metadataField: MetadataDetailsViewFragment,
  integrationType: IntegrationType,
): UseExecuteEQLInput['eqlProps'] => {
  const source: SourceNameWithNamespace = {
    name: metadataField.source ?? 'COMMON',
    namespace: metadataField.namespace,
  };

  const sourceWhereClause = sourceWhereClauseGenerator([source]);

  const metadataWhereClause = {
    filter: {
      hasMetadataFilter: {
        keys: [metadataField.key],
      },
    },
  };

  return {
    expressionType: ExpressionType.Aggregates,
    whereClause: combineWhereClauses(
      sourceWhereClause,
      metadataWhereClause,
      OperationType.AND,
    ),
    functions: [
      {
        name: EQLFunctionName.NormaliseByPercent,
        params: [integrationType, DENOMINATOR_QUERY_ALIAS],
      },
    ],
    joins: [
      {
        eql: {
          expressionType: ExpressionType.Aggregates,
          whereClause: sourceWhereClause,
          functions: [
            {
              name: EQLFunctionName.NormaliseByPercent,
              params: [integrationType],
            },
          ],
        },
        alias: DENOMINATOR_QUERY_ALIAS,
      },
    ],
  };
};
